import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router";
import { getTextColor, hasChildSelected, TextMenu } from "..";
import { useEffect, useState } from "react";
import { ArrowDownIcon, IconWrapper } from "../icon";
import { sideBarAnimationDuration, sideBarIconSize } from "common/const/const";
import styled from "styled-components";

export const SideBarItem = ({
  item,
  onClick,
  selectedKey,
  isOpen,
  level = 0,
}) => {
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();

  const { key, icon, activeIcon, label, link, children } = item;
  const expandable = Array.isArray(children) && children.length > 0;

  // state 대신 계산
  const isSelected =
    link === location.pathname ||
    selectedKey === key ||
    hasChildSelected(children, selectedKey, location);
  const IconComponent = isSelected ? activeIcon : icon;

  const [expanded, setExpanded] = useState(isOpen && isSelected);

  useEffect(() => {
    setExpanded(isOpen && isSelected);
  }, [isOpen, isSelected]);

  return (
    <>
      <SideBarItemWrapper
        onClick={(e) => {
          e.stopPropagation();
          if (link) navigate(link);
          onClick?.(key, expandable);
          if (expandable) setExpanded((prev) => !prev);
        }}>
        <IconWrapper>{IconComponent && <IconComponent />} </IconWrapper>
        <TextMenu
          color={getTextColor({ isSelected })}
          style={{ display: "flex", flexGrow: 1 }}>
          {t(`sideBar.${label}`)}
        </TextMenu>
        {expandable && (
          <IconWrapper>
            <ArrowDownIcon
              style={{
                transform: expanded ? "rotate(180deg)" : "rotate(0deg)",
                transition: `transform ${sideBarAnimationDuration} ease`,
              }}
            />
          </IconWrapper>
        )}
      </SideBarItemWrapper>
      {expandable && (
        <ExpandWrapper className={expanded ? "expanded" : ""}>
          {children.map((child) => (
            <SideBarItem
              key={child.key}
              item={child}
              onClick={onClick}
              selectedKey={selectedKey}
              level={level + 1}
              isOpen={isOpen}
            />
          ))}
        </ExpandWrapper>
      )}
    </>
  );
};

export const SideBarItemWrapper = styled.li`
  box-sizing: border-box;

  display: flex;
  gap: ${sideBarIconSize};
  width: 100%;
  height: 3.5rem;
  padding: 1rem 1.5rem;
  align-items: center;
  text-align: center;
  cursor: pointer;
`;

const ExpandWrapper = styled.div`
  overflow: hidden;
  width: 100%;
  max-height: 0;
  transition: max-height ${sideBarAnimationDuration} ease-in-out;
  will-change: max-height;
  cursor: pointer;

  &.expanded {
    max-height: 100vh;
  }
`;
